import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
var Box = withCssProps(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(BoxStyled, {
    className: className
  }, children);
});
Box.displayName = 'Box';
export { Box };
Box.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
var BoxStyled = styled.div.withConfig({
  displayName: "Box__BoxStyled",
  componentId: "sc-1i3qzsm-0"
})([""]);